import React from "react";

export const TextField = ({ label, value, onChange, maxLength }) => (
    <label className="admin-field">
        <span>{label}</span>
        <input
            type="text"
            value={value}
            maxLength={maxLength}
            onChange={(e) => onChange(e.target.value)}
        />
    </label>
);

export const TextAreaField = ({ label, value, onChange, rows = 3, maxLength }) => (
    <label className="admin-field">
        <span>{label}</span>
        <textarea
            value={value}
            rows={rows}
            maxLength={maxLength}
            onChange={(e) => onChange(e.target.value)}
        />
    </label>
);

export const SaveBar = ({ onSave, saving, savedAt, error }) => (
    <div className="admin-save-bar">
        <button
            type="button"
            className="admin-primary-button"
            onClick={onSave}
            disabled={saving}
        >
            {saving ? "Сохраняем…" : "Сохранить"}
        </button>
        {error && <span className="admin-error">{error}</span>}
        {!error && savedAt && (
            <span className="admin-saved-hint">Сохранено</span>
        )}
    </div>
);
